import React from 'react';

function Table(props: any) {
  return <table {...props} />;
}

export default Table;
